import { RouteObject } from "react-router-dom";
import { MY_TEAM_PATH, MyTeamPage } from "./pages/my-team";

export const myTeamRoutes: RouteObject[] = [
  {
    path: MY_TEAM_PATH,
    element: <MyTeamPage />,
  },
];
